
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//新建一个药品剂型
export const addDrugDosageForm = (data) => {
    return request.post("/outpatient/addDrugDosageForm", data )
}

//修改一个药品剂型
export const updateDrugDosageForm = (data) => {
    return request.post("/outpatient/updateDrugDosageForm", data )
}


/**
 * 
 * get 
 *  
 */

// 树菜单
// export const AllTree = (params) => {
//     return request.get("/outpatient/selectAllDrugCategory", { params })
// }

// 获取药品剂型
export const selectDrugDosageForm = (params) => {
    return request.get("/outpatient/selectDrugDosageForm", { params })
}

/*
 * 
 * DELETE 
 *   
 */   
// 删除药品剂型
export const deleteById = (data) => {
  return request.delete("/outpatient/deleteById", { data })
}

// 暴露
export default{
	addDrugDosageForm,updateDrugDosageForm,selectDrugDosageForm,deleteById
}